export type UseFormFieldValidation = {
  validated: Ref<boolean>;
  messages: Ref<string[]>;
};

export const useFormFieldValidation = (
  field: FormField,
  model: any
): UseFormFieldValidation => {
  const validated = ref<boolean>(false);
  const messages = ref<string[]>([]);
  const formValidationNbMax = useFormValidationNbMax(field, model);
  const formValidationRegExps = useFormValidationRegExps(field, model);
  const formValidationRequired = useFormValidationRequired(field, model);
  const formValidationDateMin = useFormValidationDateMin(field, model);
  const formValidationMatches = useFormValidationMatches(field, model);

  watchEffect(() => {
    validated.value =
      formValidationNbMax.value.validated &&
      formValidationRegExps.value.validated &&
      formValidationRequired.value.validated &&
      formValidationDateMin.value.validated &&
      formValidationMatches.value.validated;
    messages.value = [
      formValidationNbMax.value.message,
      ...formValidationRegExps.value.messages,
      formValidationRequired.value.message,
      formValidationDateMin.value.message,
      formValidationMatches.value.message,
    ].filter((message) => message !== '');
  });
  return {
    validated,
    messages,
  };
};
